exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.containerDiv[data-v-5b1922e4]{\n  margin-left: 50px;\n}\n@media screen and (max-width: 981px) {\n.containerDiv[data-v-5b1922e4]{\n      margin-left: 15px;\n      font-size: 3em;\n}\nspan[data-v-5b1922e4] {\n    margin-left: 15px;\n    margin-right: 15px;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5b1922e4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/misc/Pagination.vue
// module id = 83
// module chunks = 0